import { ChevronLeft, ChevronRight } from 'lucide-react';

interface FormNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
  isValid?: boolean;
}

export default function FormNavigation({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onSubmit,
  isLoading = false,
  isValid = true,
}: FormNavigationProps) {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div className='flex flex-col-reverse sm:flex-row justify-between gap-4 pt-8 mt-8 border-t border-gray-200'>
      {/* Botão Anterior */}
      <button
        type='button'
        onClick={onPrevious}
        disabled={isFirstStep || isLoading}
        className='flex items-center justify-center px-8 py-3.5 border border-gray-300 rounded-xl text-gray-700 font-semibold hover:bg-gray-50 hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-sm hover:shadow-md'
      >
        <ChevronLeft className='w-5 h-5 mr-2' />
        Anterior
      </button>

      {/* Botão Próximo/Finalizar */}
      {isLastStep ? (
        <button
          type='button'
          onClick={onSubmit}
          disabled={isLoading || !isValid}
          className='flex items-center justify-center px-10 py-3.5 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl font-bold hover:from-green-700 hover:to-green-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105'
        >
          {isLoading ? (
            <>
              <svg
                className='animate-spin -ml-1 mr-3 h-5 w-5 text-white'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
              >
                <circle
                  className='opacity-25'
                  cx='12'
                  cy='12'
                  r='10'
                  stroke='currentColor'
                  strokeWidth='4'
                ></circle>
                <path
                  className='opacity-75'
                  fill='currentColor'
                  d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                ></path>
              </svg>
              Finalizando...
            </>
          ) : (
            <>
              ✓ Finalizar Cadastro
            </>
          )}
        </button>
      ) : (
        <button
          type='button'
          onClick={onNext}
          disabled={isLoading || !isValid}
          className='flex items-center justify-center px-8 py-3.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-bold hover:from-blue-700 hover:to-blue-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105'
        >
          Próximo
          <ChevronRight className='w-5 h-5 ml-2' />
        </button>
      )}
    </div>
  );
}
